  import { Preference } from './Preference';
export class ProfileFormOption {
  key: string;
  value: Preference[];
}
